export const formatJobsFlyoutAsOf = (asOfToFormat: Date): string => {
  // we are not receiving the date with a UTC identifying 'Z', so we have to add it here for js to convert it properly
  const utcDate = new Date(asOfToFormat.toString() + "Z");
  return `${utcDate.toLocaleDateString()} at ${utcDate.toLocaleTimeString()}`;
}
